import { DEPLOYMENT_URL } from "../../api";
import { authGet, authPatch } from "../auth/auth";
import { patchRbacRoleBody, patchRbacRoleResponse } from "./settings/types";
import { DeploymentUsers, FeatureFlagsResponse, RbacRole } from "./types";

export const getFeatureFlags = (
  deploymentId: string
): Promise<FeatureFlagsResponse> => {
  const path = `${DEPLOYMENT_URL}/${deploymentId}/features`;
  return authGet<FeatureFlagsResponse>(path);
};

export const getDeploymentUsers = (
  deploymentId: string
): Promise<DeploymentUsers> => {
  const path = `${DEPLOYMENT_URL}/${deploymentId}/users`;
  return authGet<DeploymentUsers>(path);
};

export const patchRbacRole = (
  deploymentId: string,
  userId: number,
  newRole: RbacRole
): Promise<patchRbacRoleResponse> => {
  const body = { new_role: newRole };
  const url = `${DEPLOYMENT_URL}/${deploymentId}/users/${userId}/roles`;
  return authPatch<patchRbacRoleBody, patchRbacRoleResponse>(url, body);
};
